import "core-js/modules/es.array.map.js";
/**
 * warnOnce keys (for deduplication).
 *
 * Keep these centralized to avoid scattered magic strings.
 */

export var WarnOnceKey = {
  INBOX_MISSING_PENDING_WHEN_CLOSED: 'inbox:missingPendingWhenClosed',
  SERVER_MISSING_PENDING_WHEN_CLOSED: 'server:missingPendingWhenClosed',
  /**
   * Security warning:
   * - targetOrigin is '*'
   * - and no allowedOrigins/validateOrigin is configured
   */
  TARGET_ORIGIN_ANY_WITHOUT_ORIGIN_VALIDATION: 'targetOrigin:anyWithoutOriginValidation'
};
export function buildWarnOnceKey(prefix, ...parts) {
  if (!parts.length) return prefix;
  return `${prefix}:${parts.map(String).join(':')}`;
}